import React from 'react';

const MenuSection = ({ translations = {} }) => {
  return (
    <section id="menu" className="py-12 bg-white text-gray-800">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-4xl font-bold text-[#FF4C29] mb-8 animate-fade-in" style={{ animationDelay: '0.2s' }}>
          {translations.menuTitle || 'Our Menu'}
        </h2>
        
        <div className="relative w-full max-w-2xl mx-auto">
          <a
            href="https://qr.scan.page/uploads/pdf/QfE5Tx_56da7176ffd8530c.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#FF4C29] hover:bg-[#FF6B3D] text-white font-bold py-3 px-8 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            {translations.viewMenu || 'View Menu'}
          </a>
        </div>
      </div>
    </section>
  );
};

export default MenuSection;